import React from "react";

/**
 * FormToolbar — the toolbar that lives INSIDE a form.
 * Holds actions that operate on the form's data: save, reset, cancel,
 * validate, submit, add row, etc.
 *
 * Accepts the same slot API as PageToolbar for consistency.
 *
 * Props:
 *   left, right, children — slot content
 *   sticky  — stick to viewport top (useful for long forms)
 *   variant — "default" | "card" — card gives it a bordered card look
 */
const FormToolbar = ({
  left,
  right,
  children,
  sticky = false,
  variant = "default",
  className = ""
}) => {
  const variantClass =
    variant === "card"
      ? "ds-section-card__header border-bottom-0"
      : "ds-form-toolbar";

  return (
    <div
      className={`${variantClass} ${sticky ? "ds-form-toolbar--sticky" : ""} ${className}`}
      role="toolbar"
      aria-label="Form tools"
    >
      {left && <div className="d-flex align-items-center gap-2 flex-wrap">{left}</div>}
      {children && <div className="d-flex align-items-center gap-2 flex-wrap">{children}</div>}
      {(left || children) && right && <div className="ds-form-toolbar__spacer" />}
      {right && <div className="d-flex align-items-center gap-2 flex-wrap">{right}</div>}
    </div>
  );
};

export default FormToolbar;
